<template>
  <div class="turntable-page" :class="['turntable-level-' + currentLevel]">
    <div class="announcement-bar">
      <div class="announcement-content">
        <van-icon name="volume-o" color="#DFB372" size="14" />
        <div class="announcement-scroll">
          <div class="scroll-list">
            <div v-for="(item, idx) in announcementList" :key="idx" class="scroll-item">{{ item }}</div>
            <div v-for="(item, idx) in announcementList" :key="'dup-' + idx" class="scroll-item">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="turntable-header">
      <div class="lucky-info">
        <van-icon name="star-o" color="#DFB372" size="16" />
        <span class="lucky-num">{{ luckyNum }}</span>
        <span class="lucky-label">幸运值</span>
      </div>
      <div class="recharge-info">
        <span>累计充值 1=1 幸运值</span>
        <span class="help-icon" @click="showRule = true">?</span>
      </div>
      <div class="recharge-btn">去充值</div>
    </div>

    <div class="turntable-tabs">
      <div class="turntable-tab" v-for="(tab, idx) in turntableTabs" :key="idx"
           :class="['turntable-tab-' + idx, { active: currentLevel === idx }]" @click="currentLevel = idx">
        <div class="tab-name">{{ tab.name }}</div>
        <div class="tab-cost">
          <van-icon name="star-o" size="12" />
          {{ tab.cost }}
        </div>
      </div>
    </div>

    <div class="draw-count">
      <div class="count-item" v-for="(item, idx) in drawOptions" :key="idx"
           :class="{ active: drawCount === item.value }" @click="drawCount = item.value">
        <span class="radio-icon">
          <span class="radio-check">✓</span>
        </span>
        {{ item.label }}
      </div>
    </div>

    <!--容器背景--->
    <div class="container-bg" :style="wheelBgStyle">
         <div class="turntable-container">
            <div class="turntable-wheel" :class="{ spinning: isSpinning }" :style="wheelBgStyle">
                <img :src="wheelImage" class="wheel-img" alt="" />
                <div v-for="(prize, idx) in prizes" :key="'num-' + idx" class="prize-num-item"
                    :style="getPrizeNumStyle(idx)">
                <span class="prize-num">{{ prize.num }}</span>
                </div>
                <div v-for="(prize, idx) in prizes" :key="'img-' + idx" class="prize-img-item"
                    :style="getPrizeImageStyle(idx)">
                <img :src="prizeImage" class="prize-img" alt="" />
                </div>
                <div class="turntable-center" @click="handleDraw">
                <img :src="centerImage" class="center-img" alt="" />
                <div class="center-text">
                    <div class="times">x{{ drawCountValue }}</div>
                    <div class="draw-btn">抽奖</div>
                </div>
                </div>
            </div>
        </div>
    </div>


    <div class="record-tabs">
      <div class="record-tab" :class="{ active: recordTab === 0 }" @click="recordTab = 0">抽奖记录</div>
      <div class="record-tab" :class="{ active: recordTab === 1 }" @click="recordTab = 1">幸运值记录</div>
    </div>

    <div class="record-content">
      <div class="filter-row">
        <div class="filter-item" @click="showTime = !showTime">
          <span>{{ timeOptions[timeIndex].text }}</span>
          <van-icon name="arrow-down" size="10" />
          <div class="filter-dropdown" v-show="showTime">
            <div v-for="(opt, idx) in timeOptions" :key="idx" 
                 class="filter-option" :class="{ active: timeIndex === idx }"
                 @click="timeIndex = idx; showTime = false;">{{ opt.text }}</div>
          </div>
        </div>
        <!-- <div class="filter-item checkbox" v-if="recordTab === 0">
          <van-checkbox v-model="onlyPhysical" shape="square" checked-color="#DFB372">仅看实物</van-checkbox>
        </div> -->
        <div class="total-amount" v-if="recordTab === 0">累计中奖 {{ totalWin }}</div>
        <div class="total-amount" v-else>累计幸运值 {{ totalLucky }}</div>
      </div>

      <div class="record-list" v-if="recordList.length > 0">
        <div class="record-item" v-for="(item, index) in recordList" :key="index">
          <div class="record-time">{{ item.time }}</div>
          <div class="record-type">{{ item.type }}</div>
          <div class="record-amount" :class="item.amountType">{{ item.amount }}</div>
        </div>
      </div>
      <div class="record-empty" v-else>
        <div class="empty-icon-wrap">
          <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
        </div>
        <div class="empty-text">今日暂无记录，<span class="empty-link">可查看更多</span></div>
      </div>
    </div>

    <div class="rule-popup" v-if="showRule" @click="showRule = false">
      <div class="rule-content" @click.stop>
        <div class="rule-section">
          <div class="rule-title">幸运值获取方式</div>
          <div class="rule-text">每1累计充值可获得1幸运值，不限制充值方式</div>
        </div>
        <div class="rule-section">
          <div class="rule-title">抽奖规则说明</div>
          <div class="rule-text">1.获得的幸运值可在转盘上进行抽奖，转盘分为白银转盘、黄金转盘、钻石转盘每个转盘抽奖消耗幸运值不同，中奖金额和概率也不同，其中，白银转盘抽奖一次需消耗888幸运值；黄金转盘抽奖一次需消耗3888幸运值；钻石转盘抽奖一次需消耗18888幸运值</div>
          <div class="rule-text">2.每次抽奖，能获得对应转盘上的奖品，每轮抽奖结束，奖金都将立即自动派发到您的余额</div>
          <div class="rule-text">3.获得的幸运值仅限在Android_APP、iOS_APP端进行抽奖，同时需要已完成设置真实姓名、完成首次充值才能提现，投注不限游戏平台</div>
          <div class="rule-text">4.本活动所赠送的奖金（不含本金）需1倍有效投注才能提现，投注不限游戏平台</div>
        </div>
        <div class="rule-section">
          <div class="rule-title">条款及细则</div>
          <div class="rule-text">1.每位玩家只能使用一个账号，不可使用多账号，开设多个或被投诉账户的玩家将被取消活动资格，剩余金额可能会被没收且账户将被冻结</div>
          <div class="rule-text">2.本站保留自行决定修改、变更、终止、取消、拒绝此优惠活动的权利</div>
          <div class="rule-text">3.参与活动的玩家必须接受并遵守本活动的条款，并且申请此优惠，即代表同意接受并遵守本活动及对应条款，并且申请此优惠，即代表同意接受并遵守本活动及对应条款</div>
          <div class="rule-text">4.为避免文字理解歧义，本站保留该活动最终解释权</div>
        </div>
        <div class="rule-close" @click="showRule = false">×</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'xingyunzhuanpanComponents',
  data() {
    return {
      currentLevel: 0,
      drawCount: 50,
      recordTab: 0,
      timeIndex: 0,
      showTime: false,
      onlyPhysical: false,
      luckyNum: 0,
      totalWin: '0.00',
      totalLucky: '0.00',
      isSpinning: false,
      showRule: false,
      announcementList: [
        'ID: 172****9131 仅用888幸运值在白银转盘抽中奖金 88.00',
        'ID: 156****3210 仅用3888幸运值在黄金转盘抽中奖金 588.00',
        'ID: 145****7890 仅用18888幸运值在钻石转盘抽中奖金 1888.00',
        'ID: 167****1234 仅用888幸运值在白银转盘抽中奖金 188.00',
        'ID: 198****5678 仅用3888幸运值在黄金转盘抽中奖金 888.00',
      ],
      turntableTabs: [
        { name: '白银转盘', cost: 888, level: 1 },
        { name: '黄金转盘', cost: 3888, level: 2 },
        { name: '钻石转盘', cost: 18888, level: 3 },
      ],
      drawOptions: [
        { label: '抽1次', value: 1 },
        { label: '10连抽', value: 10 },
        { label: '50连抽', value: 50 },
      ],
      timeOptions: [
        { text: '今日', value: 0 },
        { text: '昨日', value: 1 },
        { text: '本周', value: 2 },
        { text: '本月', value: 3 },
        { text: '全部', value: 4 },
      ],
      recordList: [],
      prizesList: [
        [
          { num: '288' },
          { num: '188' },
          { num: '88' },
          { num: '388' },
          { num: '588' },
          { num: '1088' },
          { num: '2888' },
          { num: '8888' },
          { num: '666' },
          { num: '1888' },
        ],
        [
          { num: '588' },
          { num: '888' },
          { num: '1888' },
          { num: '2888' },
          { num: '3888' },
          { num: '4888' },
          { num: '6888' },
          { num: '8888' },
          { num: '10888' },
          { num: '18888' },
        ],
        [
          { num: '1888' },
          { num: '2888' },
          { num: '3888' },
          { num: '5888' },
          { num: '8888' },
          { num: '10888' },
          { num: '18888' },
          { num: '28888' },
          { num: '38888' },
          { num: '58888' },
        ],
      ],
    };
  },
  computed: {
    drawCountValue() {
      return this.drawCount;
    },
    prizes() {
      return this.prizesList[this.currentLevel];
    },
    wheelImage() {
      const imgs = [
        '/static/image/lottery/001/xyzp_zps1_01_10.avif',
        '/static/image/lottery/002/xyzp_zps2_01_10.avif',
        '/static/image/lottery/003/xyzp_zps3_01_10.avif',
      ];
      return imgs[this.currentLevel];
    },
    prizeImage() {
      const imgs = [
        '/static/image/lottery/001/luckyWheel_Icon1.png',
        '/static/image/lottery/002/luckyWheel_Icon2.png',
        '/static/image/lottery/003/luckyWheel_Icon3.png',
      ];
      return imgs[this.currentLevel];
    },
    wheelBg1() {
      const imgs = [
        '/static/image/lottery/001/xyzp_zps1_03_1.avif',
        '/static/image/lottery/002/xyzp_zps2_03_1.avif',
        '/static/image/lottery/003/xyzp_zps3_03_1.avif',
      ];
      return imgs[this.currentLevel];
    },
    wheelBg2() {
      const imgs = [
        '/static/image/lottery/001/xyzp_zps1_03_2.avif',
        '/static/image/lottery/002/xyzp_zps2_03_2.avif',
        '/static/image/lottery/003/xyzp_zps3_03_2.avif',
      ];
      return imgs[this.currentLevel];
    },
    centerImage() {
      const imgs = [
        '/static/image/lottery/001/xyzp_zps1_05.avif',
        '/static/image/lottery/002/xyzp_zps2_05.avif',
        '/static/image/lottery/003/xyzp_zps3_05.avif',
      ];
      return imgs[this.currentLevel];
    },
    wheelBgStyle() {
      return {
        backgroundImage: `url(${this.wheelBg1}), url(${this.wheelBg2})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      };
    },
  },
  methods: {
    handleDraw() {
      if (this.isSpinning) return;
      if (this.luckyNum < this.drawCount * this.turntableTabs[this.currentLevel].cost) {
        this.$root.showTost(0, '幸运值不足');
        return;
      }
      this.isSpinning = true;
      setTimeout(() => {
        this.isSpinning = false;
      this.$root.showTost(1, '恭喜中奖');
    }, 2000);
    },
    getPrizeNumStyle(idx) {
      const angle = (idx * 360 / this.prizes.length - 90) * Math.PI / 180;
      const radius = 100;
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius;
      const rotateAngle = (idx === 0 || idx === 5) ? 0 : (idx * 36);
      return {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) rotate(${rotateAngle}deg)`,
      };
    },
    getPrizeImageStyle(idx) {
      const angle = (idx * 360 / this.prizes.length - 90) * Math.PI / 180;
      const radius = 65;
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius;
      return {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.turntable-page {
  min-height: 80vh;
  margin-top: 44px;
  padding-bottom: 100px;

  &.turntable-level-0 {
    background: linear-gradient(180deg, #c8dcf0 0%, #e8f0f8 30%, #1E1F24 60%);
  }
  &.turntable-level-1 {
    background: linear-gradient(180deg, #f5e6c8 0%, #faf0dc 30%, #1E1F24 60%);
  }
  &.turntable-level-2 {
    background: linear-gradient(180deg, #e8c8f0 0%, #f3e0fa 30%, #1E1F24 60%);
  }

  .announcement-bar {
    background: #000;
    margin: 10px 5px;
    border-radius: 25px;
    background-image: url('/static/image/lottery/001/apng_xyzp_gonggao_wk_alpha.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    padding: 15px 25px;
    overflow: hidden;

    .announcement-content {
      display: flex;
      align-items: center;
      gap: 8px;

      .announcement-scroll {
        flex: 1;
        overflow: hidden;
        height: 20px;

        .scroll-list {
          animation: scrollUp 15s linear infinite;

          .scroll-item {
            font-size: 12px;
            color: #fff;
            height: 20px;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }

  @keyframes scrollUp {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-50%);
    }
  }

  .turntable-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: #000;
    border-radius: 10px;
    margin: 0 5px 10px;

    .lucky-info {
      display: flex;
      align-items: center;
      gap: 5px;

      .lucky-num {
        color: #DFB372;
        font-size: 14px;
        font-weight: bold;
      }

      .lucky-label {
        color: #fff;
        font-size: 11px;
      }
    }

    .recharge-info {
      color: #888;
      font-size: 9px;
      display: flex;
      align-items: center;
      gap: 8px;

      .help-icon {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: #DFB372;
        color: #1E1F24;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }

    .recharge-btn {
      background: #DFB372;
      color: #1E1F24;
      font-size: 11px;
      padding: 4px 12px;
      border-radius: 15px;
    }
  }

  .turntable-tabs {
    display: flex;
    justify-content: space-around;
    padding: 0 15px 15px;

    .turntable-tab {
      flex: 1;
      margin: 0 5px;
      padding: 10px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      text-align: center;
      border: 1px solid transparent;

      .tab-name {
        font-size: 13px;
        color: #888;
        margin-bottom: 5px;
      }

      .tab-cost {
        font-size: 11px;
        color: #888;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 3px;
      }

      &.active {
        .tab-name,
        .tab-cost,
        .tab-cost .van-icon {
          color: #fff !important;
        }
      }

      &.turntable-tab-0 {
        border-color: #1989fa;

        .tab-name,
        .tab-cost,
        .tab-cost .van-icon {
          color: #1989fa !important;
        }

        &.active {
          background: #1989fa;

          .tab-name,
          .tab-cost,
          .tab-cost .van-icon {
            color: #fff !important;
          }
        }
      }

      &.turntable-tab-1 {
        border-color: #ffb300;

        .tab-name,
        .tab-cost,
        .tab-cost .van-icon {
          color: #ffb300 !important;
        }

        &.active {
          background: #ffb300;

          .tab-name,
          .tab-cost,
          .tab-cost .van-icon {
            color: #fff !important;
          }
        }
      }

      &.turntable-tab-2 {
        border-color: #b37feb;

        .tab-name,
        .tab-cost,
        .tab-cost .van-icon {
          color: #b37feb !important;
        }

        &.active {
          background: #b37feb;

          .tab-name,
          .tab-cost,
          .tab-cost .van-icon {
            color: #fff !important;
          }
        }
      }
    }
  }

  .draw-count {
    display: flex;
    justify-content: center;
    gap: 15px;
    padding-bottom: 15px;

    .count-item {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 12px;
      padding: 5px 15px;
      border-radius: 20px;
      border: 1px solid #888;
      transition: all 0.2s;

      .radio-icon {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid currentColor;
        display: flex;
        align-items: center;
        justify-content: center;

        .radio-check {
          font-size: 12px;
          font-weight: bold;
          display: none;
        }
      }
    }
  }

  &.turntable-level-0 {
    .draw-count .count-item {
      color: #1989fa;
      border-color: #1989fa;

      &.active {
        background: #1989fa;
        color: #fff;

        .radio-icon {
          background: #fff;
          border-color: #fff;

          .radio-check {
            display: block;
            color: #1989fa;
          }
        }
      }
    }
  }

  &.turntable-level-1 {
    .draw-count .count-item {
      color: #ffb300;
      border-color: #ffb300;

      &.active {
        background: #ffb300;
        color: #fff;

        .radio-icon {
          background: #fff;
          border-color: #fff;

          .radio-check {
            display: block;
            color: #ffb300;
          }
        }
      }
    }
  }

  &.turntable-level-2 {
    .draw-count .count-item {
      color: #b37feb;
      border-color: #b37feb;

      &.active {
        background: #b37feb;
        color: #fff;

        .radio-icon {
          background: #fff;
          border-color: #fff;

          .radio-check {
            display: block;
            color: #b37feb;
          }
        }
      }
    }
  }

  .container-bg {
    position: relative;
    width: 9rem;
    height: 9rem;
    margin: 0 auto;
  }

  .turntable-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .turntable-wheel {
      position: relative;
      top: -0.45rem;
      width: 6.3rem;
      height: 6.3rem;
      transition: transform 2s ease-out;

      &.spinning {
        animation: spin 2s ease-out;
      }

      .wheel-img {
        width: 100%;
        height: 100%;
      }

      .prize-num-item {
        .prize-num {
          font-size: 12px;
          color: #fff;
          font-weight: bold;
        }
      }

      .prize-img-item {
        .prize-img {
          width: 35px;
          height: 35px;
        }
      }

      .turntable-center {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80px;
        height: 80px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10;

        .center-img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }

        .center-text {
          position: relative;
          z-index: 1;
          text-align: center;
          color: #fff;

          .times {
            font-size: 12px;
          }

          .draw-btn {
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .rule-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .rule-content {
      width: 320px;
      max-height: 70vh;
      overflow-y: auto;
      background: #2D2D2D;
      border-radius: 12px;
      padding: 20px;
      position: relative;

      .rule-section {
        margin-bottom: 20px;

        .rule-title {
          background: #DFB372;
          color: #1E1F24;
          font-size: 14px;
          font-weight: bold;
          padding: 4px 14px;
          border-radius: 4px;
          margin-bottom: 12px;
          display: inline-block;
        }

        .rule-text {
          color: #FFFFFF;
          font-size: 12px;
          line-height: 1.8;
          margin-bottom: 10px;
          text-align: justify;
        }
      }

      .rule-close {
        position: absolute;
        top: 10px;
        right: 10px;
        transform: none;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.6);
        border: 1px solid #DFB372;
        color: #DFB372;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(1080deg);
    }
  }

  .record-tabs {
    display: flex;
    background: #292A2C;
    margin: 15px;
    border-radius: 8px;
    overflow: hidden;

    .record-tab {
      flex: 1;
      padding: 15px;
      text-align: center;
      font-size: 14px;
      color: #888;

      &.active {
        color: #DFB372;
        background: rgba(223, 179, 114, 0.1);
      }
    }
  }

  .record-content {
    padding: 0 15px;

    .filter-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .filter-item {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 6px 12px;
        background: #292A2C;
        border-radius: 4px;
        font-size: 12px;
        color: #fff;
        position: relative;

        &.checkbox {
          background: transparent;
          padding: 0;
          color: #888;
        }

        .filter-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          margin-top: 4px;
          background: #292A2C;
          border-radius: 4px;
          overflow: hidden;
          z-index: 100;

          .filter-option {
            padding: 10px;
            text-align: center;
            font-size: 12px;
            color: #888;

            &.active {
              color: #DFB372;
              background: rgba(223, 179, 114, 0.1);
            }
          }
        }
      }

      .total-amount {
        font-size: 12px;
        color: #DFB372;
      }
    }

    .record-list {
      background: #292A2C;
      border-radius: 8px;
      overflow: hidden;

      .record-item {
        display: flex;
        padding: 12px;
        border-bottom: 1px solid #3B3C3D;

        &:last-child {
          border-bottom: none;
        }

        .record-time {
          flex: 1;
          font-size: 12px;
          color: #888;
        }

        .record-type {
          flex: 1;
          font-size: 12px;
          color: #fff;
          text-align: center;
        }

        .record-amount {
          flex: 1;
          font-size: 12px;
          color: #DFB372;
          text-align: right;

          &.minus {
            color: #ff4d4f;
          }
        }
      }
    }

    .record-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 3rem 0;

      .empty-icon-wrap {
        width: 3.5rem;
        height: 3.5rem;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.05);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.4rem;

        .empty-icon {
          width: 2.5rem;
          height: 2.5rem;
          opacity: 0.5;
        }
      }

      .empty-text {
        font-size: 0.28rem;
        color: #666;

        .empty-link {
          color: #DFB372;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/component/xingyunzhuanpan.vue